import { forwardRef, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatInputModule } from "@angular/material/input";
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { GenericDateTimePickerComponent } from "./generic-datetimepicker.component";
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from "@angular-material-components/datetime-picker";
import { NgxMatMomentModule } from "@angular-material-components/moment-adapter";
import { MatDateTimeMaskDirective } from "../directive/mat-datetime-mask.directive";

@NgModule({
  declarations: [GenericDateTimePickerComponent, MatDateTimeMaskDirective],
  imports: [CommonModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatInputModule,
    ReactiveFormsModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    NgxMatMomentModule],
  exports: [GenericDateTimePickerComponent],
})
export class GenericDateTimePickerModule { }
